module.exports = require('./lib/urlify');



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/urlify/index.js
// module id = 768
// module chunks = 0 1 2 3 4 5 6 7 8